import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserContestService } from 'src/app/services/usercontest.service';

@Component({
  selector: 'app-user-contest-leaderboard',
  templateUrl: './user-contest-leaderboard.component.html',
  styleUrls: ['./user-contest-leaderboard.component.scss']
})
export class UserContestLeaderboardComponent implements OnInit {
  contestId: string;
  showRuleList: boolean = false;
  userContestLeaderBoardDetails: any;
  eventStatictics: any;
  totalPoints: number = 0;
  name:string = 'Anish';
  userId: string;

  constructor(private activatedRoute: ActivatedRoute, private router: Router, private userContestService: UserContestService,private renderer: Renderer2,) { }

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'match-leader-page');
    this.contestId = this.activatedRoute.snapshot.paramMap.get('contestId');
    this.userId = this.activatedRoute.snapshot.paramMap.get('userId');
    let query = "filterByDisable=false&filterByStatus=true&filterByisContestRegistrationComplete=true&filterByContestId=" + this.contestId+"&filterByUserId="+this.userId;

    this.userContestService.getUserContestLeaderBoardById(query).subscribe((data: any) => {
      this.userContestLeaderBoardDetails = data.data.items[0];

      let query2 = "filterByDisable=false&filterByStatus=true&filterByMatchId=" + this.userContestLeaderBoardDetails?.matchId;
      this.userContestService.getEventStatistics(query2).subscribe((data: any) => {
        this.eventStatictics = data.data.items[0];

        this.userContestLeaderBoardDetails?.questionAnswerData.forEach(element => {
          if (this.eventStatictics?.player1Id === this.userContestLeaderBoardDetails?.playerId) {
            if (element.points === 1) {
              element['playerPoints'] = this.eventStatictics.totalPlayerOnePoints;
              element['actualPoints'] = element.points * element.playerPoints;
            }
            if (element.points === 6) {
              element['playerPoints'] = this.eventStatictics.playerOneTotalGamesWon;
              element['actualPoints'] = element.points * element.playerPoints;
            }
            if (element.points === 50) {
              element['playerPoints'] = this.eventStatictics.playerOneSetsWon;
              element['actualPoints'] = element.points * element.playerPoints;
            }
            if (element.points === 1.5) {
              element['playerPoints'] = this.eventStatictics.playerOneServicePoints;
              element['actualPoints'] = element.points * element.playerPoints;
            }
            if (element.points === 15) {
              element['playerPoints'] = this.eventStatictics.playerOneAces;
              element['actualPoints'] = element.points * element.playerPoints;
            }
            if (element.points === 20) {
              element['playerPoints'] = this.eventStatictics.playerOneTotalBreakPoints;
              element['actualPoints'] = element.points * element.playerPoints;
            }
          }
        })

        this.userContestLeaderBoardDetails?.questionAnswerDataTwo.forEach(element => {
          if (this.eventStatictics?.player2Id === this.userContestLeaderBoardDetails?.playerIdTwo) {
            if (element.points === 1) {
              element['playerPoints'] = this.eventStatictics.totalPlayerTwoPoints;
              element['actualPoints'] = element.points * element.playerPoints;
            }
            if (element.points === 6) {
              element['playerPoints'] = this.eventStatictics.playerTwoTotalGamesWon;
              element['actualPoints'] = element.points * element.playerPoints;
            }
            if (element.points === 50) {
              element['playerPoints'] = this.eventStatictics.playerTwoSetsWon;
              element['actualPoints'] = element.points * element.playerPoints;
            }
            if (element.points === 1.5) {
              element['playerPoints'] = this.eventStatictics.playerTwoServicePoints;
              element['actualPoints'] = element.points * element.playerPoints;
            }
            if (element.points === 15) {
              element['playerPoints'] = this.eventStatictics.playerTwoAces;
              element['actualPoints'] = element.points * element.playerPoints;
            }
            if (element.points === 20) {
              element['playerPoints'] = this.eventStatictics.playerTwoTotalBreakPoints;
              element['actualPoints'] = element.points * element.playerPoints;
            }
          }
        })

        setTimeout(() => {
          this.totalPoints = [...this.userContestLeaderBoardDetails?.questionAnswerData, ...this.userContestLeaderBoardDetails?.questionAnswerDataTwo]
            .reduce((total, ele) => total + ele.actualPoints, 0);
        }, 100);
      })
    })
  }
  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'match-leader-page');
  }

  onClickViewLeaderBoard() {
    this.router.navigate(['/contest-leader-board/' + this.contestId]);
  }

  showRulelist() {
    this.showRuleList = true;
  }

}
